<template>
    <df-admin-form :editing="isEditing" :loading="loading" @submit="submit" @cancel="$router.push({ name: 'admin-customers' })">

        <div class="email-compose-fields">
            <text-field horizontal label="Name" v-model="data.name" :validation="$v.data.name"/>
            <text-field horizontal label="Website" v-model="data.website" :validation="$v.data.website"/>
        </div>
        <div class="email-compose-fields">
            <text-field horizontal label="Strasse" v-model="data.street" :validation="$v.data.street"/>
            <text-field horizontal label="PLZ" v-model="data.postcode" :validation="$v.data.postcode"/>
            <text-field horizontal label="Ort" v-model="data.location" :validation="$v.data.location"/>
            <select-menu horizontal label="Land" :options="countries" v-model="data.country" :validation="$v.data.country"/>
        </div>

    </df-admin-form>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required, url, maxLength } from 'vuelidate/lib/validators';
    import { postal } from '../../../../validators';
    import adminForm from '../../../../mixins/adminForm';
    import Customer from '../../../../models/Customer';
    import Countries from '../../../../data/Countries';

    export default {
        mixins: [adminForm],

        data: () => ({
            model: Customer,
        }),

        validations: {
            data: {
                name: { required, maxlength: maxLength(255) },
                website: { required, url, maxlength: maxLength(255) },
                street: { maxlength: maxLength(255) },
                postcode: { required, postal: postal('country') },
                location: { required, maxlength: maxLength(255) },
                country: { required },
            },
        },

        computed: {
            ...mapGetters('user', ['user']),
        },

        asyncComputed: {
            countries: () => Countries.all(),
        },

        methods: {
            async submit() {
                if (!this.source || !this.source.coach) {
                    this.data.coach = this.user.resourceId;
                }

                if (await this.saveForm()) {
                    this.$router.push({ name: 'admin-customers' });
                }
            },
        },
    };
</script>
